import CustomerApiService from "@/core/services/apiServices/CustomerApiService";
import PaginationService from "@/core/services/PaginationService";
import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators";
import store from "..";
import { Actions, Mutations } from "../enums/StoreEnums";

@Module
export default class TableModule extends VuexModule {
    page = 1;
    pageSize = 10;
    totalDataCount = 0;
    error = "";
    dataType = "";
    data: Array<any> | null = null;
    loading = false;
    fetch = false;
    export = false;
    blockHardClear = false;
    companiesList: any[] = [];
    interval: number | undefined;

    get companies() {
        return this.companiesList;
    }
    get getPage() {
        const currentPageAndPageSize = PaginationService.getPageAndPageSize();
        if (currentPageAndPageSize && currentPageAndPageSize.page !== this.page) {
            store.commit(Mutations.SET_PAGE, currentPageAndPageSize.page);
        }
        return this.page;
    }
    get getPageSize() {
        const currentPageAndPageSize = PaginationService.getPageAndPageSize();
        if (currentPageAndPageSize && currentPageAndPageSize.pageSize !== this.pageSize) {
            store.commit(Mutations.SET_PAGE_SIZE, currentPageAndPageSize.pageSize);
        }
        return this.pageSize;
    }
    get getTotalDataCount() {
        return this.totalDataCount;
    }
    get getTableError() {
        return this.error;
    }
    get getDataType() {
        return this.dataType
    }
    get getTableData() {
        return this.data;
    }
    get isLoading() {
        return this.loading;
    }
    get fetchRequested() {
        return this.fetch
    }
    get exportRequested() {
        return this.export
    }
    get isHardClearBlocked() {
        return this.blockHardClear
    }

    @Mutation
    [Mutations.SET_PAGE](page: number) {
        store.commit(Mutations.SET_FETCH_DATA, false);
        PaginationService.setPage(page);
        this.page = page;
    }

    @Mutation
    [Mutations.SET_FETCH_DATA](fetch: boolean) {
        this.fetch = fetch;
    }

    @Mutation
    [Mutations.SET_EXPORT_DATA](exportData: boolean) {
        this.export = exportData;
    }

    @Mutation
    [Mutations.SET_TABLE_LOADING](isLoading: boolean) {
        this.loading = isLoading;
    }

    @Mutation
    [Mutations.SET_COMPANIES](companies: []) {
        this.companiesList = companies;
    }

    @Mutation
    [Mutations.SET_PAGE_SIZE](pageSize: number) {
        store.commit(Mutations.SET_FETCH_DATA, false);
        PaginationService.setPageSize(pageSize);
        this.pageSize = pageSize;
    }

    @Mutation
    [Mutations.SET_TOTAL_DATA_COUNT](count: number) {
        this.totalDataCount = count;
    }

    @Mutation
    [Mutations.SET_TABLE_ERROR](error: string) {
        this.error = error;
    }

    @Mutation
    [Mutations.SET_TABLE_DATA_TYPE](type: string) {
        this.dataType = type;
    }

    @Mutation
    [Mutations.SET_TABLE_DATA](data: Array<any> | null) {
        if (data && this.companiesList) {
            this.data = data.map((data) => {
                const company = this.companiesList.find(p => p.id == data.companyId);
                data.company = company ? company.name : "-";
                return data;
            });
        }
        else {

            this.data = data;
        }
        this.data = data;
    }

    @Mutation
    [Mutations.SET_BLOCK_HARD_CLEAR](block: boolean) {
        this.blockHardClear = block
    }

    @Action
    [Actions.CLEAR_TABLE_DATA](hardClear = false) {
        this.context.dispatch(Actions.FETCH_COMPANY_LIST);
        this.context.commit(Mutations.SET_TOTAL_DATA_COUNT, 0);
        this.context.commit(Mutations.SET_TABLE_DATA, null);
        this.context.commit(Mutations.SET_TABLE_DATA_TYPE, "")

        if (hardClear && !this.blockHardClear) {
            setTimeout(() => {
                this.context.commit(Mutations.SET_PAGE, 1);
                this.context.commit(Mutations.SET_PAGE_SIZE, 10);
            }, 0);
        }
        else {
            const currentPageAndPageSize = PaginationService.getPageAndPageSize();
            if (currentPageAndPageSize) {
                this.context.commit(Mutations.SET_PAGE, currentPageAndPageSize.page);
                this.context.commit(Mutations.SET_PAGE_SIZE, currentPageAndPageSize.pageSize);
            }
            else {
                this.context.commit(Mutations.SET_PAGE, 1);
                this.context.commit(Mutations.SET_PAGE_SIZE, 10);
            }
        }
        store.commit(Mutations.SET_BLOCK_HARD_CLEAR, false)
        this.context.commit(Mutations.SET_TABLE_ERROR, "");
    }

    @Action
    [Actions.REFRESH_TABLE_DATA]() {
        this.context.dispatch(Actions.CLEAR_TABLE_DATA, true)
    }

    @Action
    [Actions.FETCH_COMPANY_LIST](force = false) {
        if (this.context.getters.isGlobalAdmin && (force || this.companies.length === 0)) {
            const getCompanies = () => {
                CustomerApiService.CustomerManagement.Company.GetForSelect()
                    .then((response) => {
                        this.context.commit(Mutations.SET_COMPANIES, response.data.data.map(function (company) {
                            return {
                                id: company.id,
                                name: company.name
                            };
                        }));
                    });
            }

            getCompanies();

            if (this.interval) {
                clearInterval(this.interval);
            }
            this.interval = setInterval(() => {
                getCompanies();
            }, 1000 * 60 * 60); // refresh every hour
        }
    }

    @Action
    [Actions.HANDLE_COLLECTION_RESULT](result: any | Error) {
        if (result.dataType && result.dataType === this.dataType) {
            this.context.commit(Mutations.SET_TABLE_LOADING, true)

            setTimeout(() => {
                if (result instanceof Error) {
                    this.context.commit(Mutations.SET_TABLE_ERROR, result.message);
                    this.context.commit(Mutations.SET_TABLE_DATA, null);
                    this.context.commit(Mutations.SET_TOTAL_DATA_COUNT, 0);
                }
                else {
                    const errorMessage = (result.messages as any[]).find(p => p.isError)
                    if (errorMessage) {
                        this.context.commit(Mutations.SET_TABLE_ERROR, errorMessage.description);
                    }

                    this.context.commit(Mutations.SET_TABLE_DATA, result.data);
                    this.context.commit(Mutations.SET_TOTAL_DATA_COUNT, result.totalItemCount);
                }

                setTimeout(() => {
                    this.context.commit(Mutations.SET_TABLE_LOADING, false)
                }, 0);
            }, 0);
        }
    }
}